import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ViewTabs } from "../components/ViewTabs";
import { Wheat } from "lucide-react";
import FeedingHorses from "./FeedingHorses";
import FeedingConfig from "./FeedingConfig";

export default function Feeding() {
  const [params] = useSearchParams();
  const [view, setView] = useState("horses");

  return (
    <div className="space-y-6 eq-fade-up" data-testid="feeding-page">
      <div>
        <p className="font-mono-label text-[#8C532B] text-xs">Razioni, alimenti e consumi</p>
        <h1 className="font-display text-2xl lg:text-3xl font-bold text-[#1B3B2B] flex items-center gap-2">
          <Wheat className="h-6 w-6 text-[#8C532B]" /> Alimentazione
        </h1>
      </div>

      <ViewTabs value={view} onChange={setView}
        options={[
          { value: "horses", label: "Cavalli", testid: "feeding-tab-horses" },
          { value: "config", label: "Configurazione", testid: "feeding-tab-config" },
        ]} />

      {view === "horses" ? <FeedingHorses initialHorse={params.get("horse")} /> : <FeedingConfig />}
    </div>
  );
}
